import { variant } from 'styled-system';
import theme from '@sergiogc9/react-ui-theme';

export default variant({
	prop: 'aspectSize',
	variants: theme.components.chip.sizes.iconWrapper
});
